import React from "react";
import location from "../assets/images/locationIcon.svg";
import phoneIcon from "../assets/images/phoneIcon.svg";
import facebook from "../assets/images/facebookIcon.svg";
import "../assets/css/footer.css";

export const Footer = (data) => {
  const phone = data.data.phoneNumber
  const numberIcon = data.data.phoneNumberIcon
  return (
    <div className="footer">
      <h2>CONTACTO</h2>
      <ul>
        <li>
          {" "}
          <img src={location} alt="Location" /> Argentina{" "}
        </li>
          <>
            <li>
              {" "}
              <a href={`tel:${phone}`}>
                <img src={phoneIcon} alt="Phone" /> {numberIcon}
              </a>
            </li>
          </>
        <li>
          {" "}
          <img src={facebook} alt="Facebook" /> Alarmas interactivas
        </li>
      </ul>
    </div>
  );
};
